import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import { Text, TextPreset, Color } from '@pegasus/ui-components/components/text';
import Translate from '@client/components/shared/translation/Translate';

import styles from './deliveryLabel.scss';

export function DeliveryLabel({ message, translationId, hover }) {

    if ((!message || message.length === 0) && (!translationId || translationId.length === 0)) {
        return null;
    }

    const classes = classNames(
        'wrapper',
        {
            'wrapper--hovered': hover
        }
    );

    return (
        <div styleName={classes}>
            <Text preset={TextPreset.XXS} color={Color.bright} uppercase>
                {translationId ? <Translate message={translationId} /> : message}
            </Text>
        </div>
    );
}

DeliveryLabel.propTypes = {
    message: PropTypes.string,
    translationId: PropTypes.string,
    hover: PropTypes.bool
};

export default CSSModules(DeliveryLabel, styles, { allowMultiple: true });
